
import { useStore } from '@/store'
import { computed, defineComponent, inject, onUnmounted, ref, watch } from 'vue'
import * as RenderingConstants from '@/constants/rendering-constants'
import RenderingPathService from '@/services/rendering/rendering-path.service'
import bodySettings from '@/settings/body-settings.json'
import threadSettings from '@/settings/thread-settings.json'
import sideSettings from '@/settings/side-settings.json'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'RenderingRandselSide',
  props: {
    cameraPos: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const store = useStore()
    const emitter: any = inject('emitter')
    const configBodyId = computed(() => store.getters.configBodyId)
    const configThreadId = computed(() => store.getters.configThreadId)
    const configSideId = computed(() => store.getters.configSideId)
    let imagePath = ref('')
    let renderPathService = new RenderingPathService()

    emitter.on('updateConfig', updateRendering)

    // prettier-ignore
    watch(() => configBodyId.value, (_) => { updateRendering() })
    // prettier-ignore
    watch(() => configThreadId.value, (_) => { updateRendering() })
    // prettier-ignore
    watch(() => configSideId.value, (_) => { updateRendering() })

    function updateRendering() {
      try {
        const bodyId = renderPathService.formatConfig(configBodyId.value, bodySettings.fullorderColors)
        const threadId = renderPathService.formatConfig(configThreadId.value, threadSettings.threadColors)
        const sideId = renderPathService.formatConfig(configSideId.value, sideSettings.sideTextures)
        setRendering(bodyId, threadId, sideId)
      } catch (err) {
        SentrySingleton.instance.captureException(err)
      }
    }

    function setRendering(bodyId: string | null, threadId: string | null, sideId: string | null) {
      if (!bodyId || !threadId || !sideId) {
        if (!bodyId) {
          console.error('cannot find body id for RenderingRandselSide')
        }
        imagePath.value = ''
        return
      }
      const camPath = 'cam' + (props.cameraPos + 1) + '/'
      const optionPath = 'side/' + bodyId + '/' + threadId + '/' + sideId + '.png'
      const path = RenderingConstants.path + camPath + optionPath
      imagePath.value = path
    }

    onUnmounted(() => {
      emitter.off('updateConfig', updateRendering)
    })

    return {
      imagePath
    }
  }
})
